<script setup lang="ts">
import { computed } from "vue";
import { usePage, Link } from "@inertiajs/vue3";
import { DateTime } from "luxon";
import { PagePropsInterface } from "@interfaces/PagePropsInterface";
import { FooterNavigationInterface } from "@interfaces/FooterNavigationInterface.js";
import PaymentMethods from "@components/payment-methods.vue";
import { trans } from "laravel-vue-i18n";

let page = usePage<PagePropsInterface>();

const navigations = computed<Array<FooterNavigationInterface>>(() => [
    {
        title: trans("sections.also_known_as"),
        items: [
            {
                name: trans("sections.standing_desks"),
                url: route("landing.standing"),
            },
            {
                name: trans("sections.adjustable_desks"),
                url: route("landing.adjustable"),
            },
            {
                name: trans("sections.ergonomic_desks"),
                url: route("landing.ergonomic"),
            }
        ]
    },
    {
        title: trans("sections.our_company"),
        items: [
            {
                name: trans("sections.about_us"),
                url: route("about"),
            },
            {
                name: trans("sections.faq"),
                url: route("faq"),
            },
            {
                name: "Support",
                url: route("contact"),
            }
        ]
    },
    {
        title: "Social",
        items: [
            {
                name: "Facebook",
                url: page.props.application.socials.facebook,
                redirect: true,
            },
            {
                name: "Instagram",
                url: page.props.application.socials.instagram,
                redirect: true,
            },
        ]
    },
    {
        title: "Legal",
        items: [
            {
                name: trans('pages.terms.title'),
                url: route("terms"),
            },
            {
                name: trans('pages.privacy.title'),
                url: route("privacy"),
            },
            {
                name: trans('pages.cookies.title'),
                url: route("cookies"),
            },
            {
                name: trans('pages.return.title'),
                url: route("return"),
            }
        ]
    }
]);

</script>
<template>
    <footer id="layouts-section-footer">
        <div class="container">
            <div v-if="navigations.length > 0" class="top-footer">
                <div class="navigations">
                    <nav v-for="navigation in navigations" :key="navigation.title" class="footer-navigation">
                        <p>
                            {{ navigation.title }}
                        </p>
                        <ul>
                            <li v-for="item in navigation.items" :key="item.name">
                                <Link v-if="!item.redirect" :href="item.url">
                                <span>
                                    {{ item.name }}
                                </span>
                                <span v-if="item.new" class="new">
                                    New
                                </span>
                                </Link>
                                <a hreflang="nl" v-else :href="item.url" target="_blank">
                                    {{ item.name }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="payment-methods">
                    <payment-methods></payment-methods>
                </div>

            </div>
            <div class="footer-divider"></div>
            <div class="bottom-footer">
                <div class="logo">
                    <img :src="page.props.application.logo.normal" alt="logo LevelUp Desk" />
                </div>
                <div class="copyright">
                    <p>
                        © {{ DateTime.now().year }}
                        <a hreflang="nl" target="_blank" href="https://www.libaro.be">Libaro bv.</a>
                        All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>
<style scoped lang="scss">
@use "@scss/layouts/sections/footer";
</style>
